<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
	export default {
		name: '',
		components: {},
		data: function() {
			return {
				headDataI: getdata().headDataI,
				option:[{
					value:'302170100',
					label:'娱乐业文化事业建设费'
				},{
					value:'302170200',
					label:'广告业文化事业建设费'
				}]
			};
		},
		props: {
			showpz: {
				type: Boolean,
				default: false
			},
			tableDataI: {
				type: Array,
				default: [],
			},
			tableDataII:{
				type: Object,
				default: {},
			},
			headobj: {
				type: Object,
				default: {},
			},
			choosecellCode: {
				type: String,
				default: ""
			},
			type: {
				type: String,
				default: ""
			},
			toseeUpdate: {
				type: Boolean,
				default: false
			}
		},
		created() {
		},
		methods: {
			selectchange(){
				this.option.map(item=>{
					if(item.value==this.headobj.sbpm){
						this.headobj.sbpmmc = item.label
					}
				})
				this.$emit("updataheadobj", this.headobj)
			},
			onchange(){
				this.$forceUpdate()
			},
			inputblur(e) {
				this.$emit("inputblur", e)
			},
			forhover(table, colum, index) {
				this.$emit("forhover", table, colum, index)
			},
			zcsclick(e) {
				this.$emit("zcsclick", e)
			},
			headchange(e){
				this.$emit("headchange", this.headobj)
			},
			headercellstyle({
				row,
				column,
				rowIndex,
				columnIndex
			}){
				if (rowIndex === 0) {
					if (columnIndex === 0) {
						this.$nextTick(() => {

							if (document.getElementsByClassName(column.id).length !== 0) {
								document
									.getElementsByClassName(column.id)[0]
									.setAttribute('rowspan', 2);
							}
						});
					}
				}
			},
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if(columnIndex === 0){
					if(rowIndex === 2){
						return {
							rowspan: 8,
							colspan: 1
						};
					} else if(rowIndex === 10){
						return {
							rowspan: 9,
							colspan: 1
						};
					}else{
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}else if (columnIndex === 1) {
					if (rowIndex === 0) {
						return {
							rowspan: 2,
							colspan: 2
						};
					} else if(rowIndex === 4){
						return {
							rowspan: 1,
							colspan: 1
						};
					} else if(rowIndex === 5){
						return {
							rowspan: 1,
							colspan: 1
						};
					} else {
						return {
							rowspan:0,
							colspan:0
						};
					}
				}else if(columnIndex === 2){
					if(rowIndex === 0){
						return {
							rowspan: 1,
							colspan: 1
						};
					}else if(rowIndex === 1){
						return {
							rowspan: 1,
							colspan: 1
						}
					} else if(rowIndex === 4){
						return {
							rowspan: 1,
							colspan: 1
						}
					}else if(rowIndex === 5){
						return {
							rowspan: 1,
							colspan: 1
						}
					}else{
						return {
							rowspan: 1,
							colspan: 2
						}
					}
				}
			}
		},
		
	}
</script>

<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SmallScaleVAT/index.less');
</style>
